import { Component, ChangeDetectionStrategy, Inject } from "@angular/core";
import { FormFieldComponent } from "../form-field-component";
import { FIELD_FORM_CONTROL, FIELD_NAME } from "../form-field-injector";

@Component({
  selector: "dynamic-form-string-default",
  template: `
    <div>
      <label>{{ name }}: </label>
      <input type="text" [formControl]="formControl" />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleInputComponent implements FormFieldComponent {
  constructor(@Inject(FIELD_FORM_CONTROL) public formControl, @Inject(FIELD_NAME) public name: string) {}
}
